<template>
    <div class="relative flex"
         v-click-outside="closeDropdown"
    >
        <div class="absolute -top-2 left-10 bg-blue-50 text-xs px-2">
            Вкладка
        </div>
        <div class="w-full h-full border border-gray-400 cursor-pointer hover:border-gray-700 flex justify-start items-center select-none lg:rounded-md"
             v-on:click="openDropdown">
            <div v-if="!props.isLoading" class="whitespace-nowrap text-ellipsis overflow-x-hidden px-4">
                {{ selectedTab?.sheetTitle }}
            </div>
            <div v-else class="px-4">
                Загружаем вкладки...
            </div>
            <ArrowSvg class="ml-auto mr-5"/>
        </div>
        <div class="w-full absolute bg-white border shadow-xl max-h-[calc(158px)] overflow-auto rounded-md -top-5"
             :class="{'invisible': !isVisible, 'visible': isVisible}"
        >
            <div class="py-2 px-2 items-center justify-center text-gray-500 text-xs font-bold select-none">
                Выбрать вкладку
            </div>
            <ul>
                <li
                    class="py-4 px-2 items-center justify-center cursor-pointer select-none"
                    :class="{
                        'bg-gray-200': tab === selectedTab,
                        'hover:bg-gray-100': tab !== selectedTab,
                    }"
                    v-for="tab in props.tabs" v-bind:key="tab"
                    v-on:click="saveTab(tab)"
                >
                    {{tab?.sheetTitle}}
                </li>
            </ul>
        </div>
    </div>
</template>


<script setup>
import ArrowSvg from "@/components/UI/ArrowSvg.vue";
import {defineModel, defineProps, ref} from 'vue'


const selectedTab = defineModel("selectedTab")

const isVisible = ref(false)

const props = defineProps({
    tabs: {
        type: Array,
        required: true,
    },
    isLoading: {
        type: Boolean,
        required: true,
    },
})

function openDropdown() {
    if (!props.isLoading) {
        isVisible.value = true
        let documentBody = document.getElementsByTagName('body')[0]
        documentBody.style.overflow = 'hidden'
    }
}
function closeDropdown() {
    isVisible.value = false
    let documentBody = document.getElementsByTagName('body')[0]
    documentBody.style.overflow = null
}
function saveTab(tab) {
    selectedTab.value = tab
    console.log(selectedTab._value)
    closeDropdown()
}
</script>